export default __webpack_public_path__ + "static/media/logo.dbeed7b4.svg";